import Swal from "sweetalert2";

export * from "./makeGroup";
export * from "./numberFormatter";
export * from "./panelOverviewFormat";

export const apiNotification = ({ message, warn = false }) => {
  if (warn) {
    Swal.fire({
      title: "",
      text: message,
      icon: "warning",
      timer: 2000,
      confirmButtonText: "OK",
    });
  } else {
    Swal.fire({
      title: "Done!",
      text: message,
      icon: "success",
      timer: 2000,
      confirmButtonText: "OK",
    });
  }
};

export const showAlert = ({ message, success }) => {
  Swal.fire({
    title: success ? "Done!" : "Warning!",
    text: message || "Something is wrong.",
    icon: success ? "success" : "warning",
    timer: 2000,
    button: false,
  });
};

export const numberFormater = (numb) => {
  const options = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };
  return Number(numb || 0).toLocaleString("en", options);
};
